import React from 'react';

import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';
import { Button } from '@eika/button';
import { InfoCard } from '@eika/card';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import { ErrorCardWrapper } from '../../components/shared/ErrorCardWrapper';
import useTranslation from '../../hooks/useTranslation';
import TransacitionListNoMoreContent from './TransacitionListNoMoreContent';

type TransactionListStatusProps = {
    refresh: () => void;
    error: RequestExceptionWithResponse | null;
    noContent: { value: boolean; title: string; goToSearch: () => void; isFilter: boolean };
    isFuturePayments?: boolean;
};

const TransactionListStatus: React.FC<TransactionListStatusProps> = ({
    noContent,
    error,
    refresh,
    isFuturePayments = false,
}) => {
    const translated = useTranslation();

    if (error) {
        return (
            <>
                <ErrorCardWrapper
                    exception={error}
                    defaultError={translated.transactionListCouldNotGetTransactions}
                    className="transaction-list-widget__error-card"
                    iconType={RichIconTypes.NETTVERKSBRUDD_HARE}
                >
                    <Button onClick={refresh}>{translated.tryAgain}</Button>
                </ErrorCardWrapper>
            </>
        );
    }

    if (isFuturePayments && noContent.value) {
        return (
            <InfoCard skipBackground>
                <RichIcon type={RichIconTypes.BAAT_M_SOL} />
                <InfoCard.TitleH2>{noContent.title}</InfoCard.TitleH2>
            </InfoCard>
        );
    }

    return (
        <TransacitionListNoMoreContent
            isFilter={noContent.isFilter}
            goToSearch={noContent.goToSearch}
            show={noContent.value}
        />
    );
};

export default TransactionListStatus;
